module.exports = __webpack_public_path__ + "img/pg5-article-bg.ae5d8c78.png";